<template>
	<div>
		<div v-if="options && !gotoPageDisabled">
			<div v-if="showGoToPage">
				<form-row label="Goto Page">
					<select class="form-control" v-model="options.gotoPageIndex" v-on:blur="sendUpdate()">
						<option :value="n" v-bind:key="n" v-for="n in possibleGotoIndices">#{{ n + 1 }}</option>
					</select>
				</form-row>
			</div>
			<div v-if="pageType == 'dilemma' && position == 'Left'">
				<form-row label="Show Back Button">
					<select class="form-control" v-model="options.backButton" v-on:blur="sendUpdate()">
						<option :value="false">False</option>
						<option :value="true">True</option>
					</select>
				</form-row>
			</div>
		</div>
		<div class="card text-white bg-dark my-3">
			<div class="card-header row mx-0 p-2">
				<div class="col-8">
					{{position}} Component
				</div>
			</div>
			<div class="card-body py-1">
				<form-row label="Type">
					<select class="form-control" v-model="componentIndex">
						<option :value="n" v-bind:key="type" v-for="(type, n) in componentTypes">{{ type }}</option>
					</select>
				</form-row>
				<div class="my-3" style="border-bottom: 2px dashed white"/>
				<div v-if="options">
					<form-row label="Text">
						<markdown-editor v-model="options.text" v-on:input="sendUpdate()"></markdown-editor>
					</form-row>
					<div v-if="component == 'RawMedia' || component == 'Phone'">
						<form-row label="Media">
							<select class="form-control" v-model="selectedMediaType">
								<option value="video">Video Link</option>
								<option value="image">Image</option>
							</select>
						</form-row>
						<div v-if="selectedMediaType == 'video'">
							<form-row label="Link">
								<input class="form-control" type="text" v-bind:class="{'is-invalid': !isMediaLinkValid}"
								       v-model="options.media" v-on:blur="sendUpdate()"/>
								<div class="invalid-feedback">
									Please provide a valid link
								</div>
							</form-row>
						</div>
						<div v-else>
							<image-picker :showImage="true" :showUploader="false" v-model="options.media"
							              v-on:change="sendUpdate()"/>
						</div>
					</div>
					<div v-else-if="component == 'Points'">
						<form-row :label="'Point ' + (i+1)" v-bind:key="i" v-for="(point, i) in options.points">
							<markdown-editor v-model="options.points[i]" v-on:input="sendUpdate()"></markdown-editor>
						</form-row>
						<div class="d-flex justify-content-center my-3">
							<button class="btn btn-danger btn-sm"
							        v-bind:class="{'disabled': (!options.points || options.points.length <= 1)}"
							        v-on:click="deletePoint(options.points.length - 1)">Delete Point
							</button>
							<div style="width: 20px"/>
							<button class="btn btn-success btn-sm" v-on:click="addPoint()">Add New Point</button>
						</div>
					</div>
					<div v-else-if="component == 'Choices'">
						<form-row label="Result Type">
							<select class="form-control" v-model="options.resultType" v-on:blur="sendUpdate()">
								<option :value="type" v-bind:key="type" v-for="type in resultTypes">{{ type }}</option>
							</select>
						</form-row>
						<div v-if="options.resultType == 'correctAnswer'">
							<form-row label="Correct Index">
								<select class="form-control" v-model="options.correctIndex" v-on:blur="sendUpdate()">
									<option :value="n - 1" v-bind:key="n" v-for="n in options.choices.length">{{ n }}
									</option>
								</select>
							</form-row>
						</div>
						<div class="card text-white bg-dark my-3" v-bind:key="i" v-for="(choice, i) in options.choices">
							<div class="card-header row mx-0 p-2">
								<div class="col-8">
									Choice {{i + 1}}
								</div>
								<div class="col d-flex justify-content-end">
									<button class="btn btn-sm btn-danger" v-on:click="deleteChoice(i)">Delete</button>
								</div>
							</div>
							<div class="card-body py-1">
								<form-row label="Format">
									<select class="form-control" v-model="choice.format" v-on:blur="sendUpdate()">
										<option :value="formatTypes[j]" v-bind:key="format"
										        v-for="(format, j) in formatTypes">{{ format }}
										</option>
									</select>
								</form-row>
								<form-row label="Goto Page"
								          v-if="!gotoPageDisabled && (options.resultType == 'chooseAnswer' || (options.resultType == 'correctAnswer' && options.correctIndex == i))">
									<select class="form-control" v-model="choice.gotoPageIndex"
									        v-on:blur="sendUpdate()">
										<option :value="n" v-bind:key="n" v-for="n in possibleGotoIndices">#{{ n + 1
											}}
										</option>
									</select>
								</form-row>
								<form-row label="Message">
									<markdown-editor v-model="choice.message"
									                 v-on:input="sendUpdate()"></markdown-editor>
								</form-row>
							</div>
						</div>
						<div class="d-flex justify-content-center my-3">
							<button :disabled="options.choices.length >= 6" class="btn btn-success btn-sm"
							        v-on:click="addChoice()">Add New Choice
							</button>
						</div>
					</div>
					<div v-else-if="component == 'Script'">
						<div class="card text-white bg-dark my-3" v-bind:key="i"
						     v-for="(dialogue, i) in options.dialogue">
							<div class="card-header row mx-0 p-2">
								<div class="col-8">
									Dialogue {{i + 1}}
								</div>
								<div class="col d-flex justify-content-end">
									<button class="btn btn-sm btn-danger" v-on:click="deleteDialogue(i)">Delete</button>
								</div>
							</div>
							<div class="card-body py-1">
								<form-row label="Action">
									<input class="form-control" type="text" v-model="options.dialogue[i].action"
									       v-on:blur="sendUpdate()"/>
								</form-row>
								<form-row label="Sentence">
									<input class="form-control" type="text" v-model="options.dialogue[i].sentence"
									       v-on:blur="sendUpdate()"/>
								</form-row>
							</div>
						</div>
						<div class="d-flex justify-content-center my-3">
							<button :disabled="options.dialogue.length >= 2" class="btn btn-success btn-sm"
							        v-on:click="addDialogue()">Add New Dialogue
							</button>
						</div>
						<form-row label="Next Message">
							<input class="form-control" type="text" v-model="options.nextMessage"
							       v-on:blur="sendUpdate()"/>
						</form-row>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import FormRow from '@/components/form-row';
	import MediaManager from '@/media-manager';
	import ImagePicker from '@/components/image-picker';
	import MarkdownEditor from '@/components/markdown-editor';

	export default {
		name: 'component-editor',
		props: {
			content: {
				type: Object
			},
			position: {
				type: String
			},
			pagesInCase: {
				type: Number
			},
			pageIndex: {
				type: Number
			},
			pageType: {
				type: String
			}
		},
		components: {
			FormRow,
			ImagePicker,
			MarkdownEditor
		},
		data() {
			return {
				componentIndex: 0,
				options: null,
				selectedMediaType: 'image'
			}
		},
		mounted() {
			if (this.content) {
				this.componentIndex = this.componentTypes.indexOf(this.content.component);
				this.options = this.content.options;

				if (this.component == 'RawMedia' || this.component == 'Phone') {
					this.selectedMediaType = this.isMediaLinkValid ? 'video' : 'image';
				}
			} else {
				this.setDefaultOptions();
				this.sendUpdate();
			}

			this.$watch('componentIndex', () => {
				this.setDefaultOptions();
				this.sendUpdate();
			});
		},
		methods: {
			sendUpdate() {
				this.sanitizeOptions();

				this.$emit('updated', {
					component: this.component,
					options: this.options
				});
			},
			sanitizeOptions() {
				if (this.component === 'Choices') {
					if (this.options.resultType !== 'correctAnswer') {
						if (this.options.hasOwnProperty('correctIndex')) {
							Vue.delete(this.options, 'correctIndex');
						}
					}

					if (this.options.resultType !== 'chooseAnswer' && this.options.hasOwnProperty('choices') && this.options.choices) {
						for (let i = 0, len = this.options.choices.length; i < len; i++) {
							if (this.options.choices[i].hasOwnProperty('gotoPageIndex')) {
								Vue.delete(this.options.choices[i], 'gotoPageIndex');
							}
						}
					}
				}


				if (this.component === 'Choices' && this.options.resultType === 'noAnswer' && this.options.hasOwnProperty(
					'gotoPageIndex')) {
					Vue.delete(this.options, 'gotoPageIndex');
				}

				if ((this.pageType === 'roleplay' || this.isLastPage || this.position === 'Right') && this.options.hasOwnProperty(
					'gotoPageIndex')) {
					Vue.delete(this.options, 'gotoPageIndex');
				}

				if (this.position == 'Right' && this.options.hasOwnProperty('backButton')) {
					Vue.delete(this.options, 'backButton');
				}

                if (this.gotoPageDisabled) {
                    Vue.delete(this.options, 'gotoPageIndex')

                    if (this.options.choices) {
                        for (const choice of this.options.choices) {
                            Vue.delete(choice, 'gotoPageIndex')
                        }
                    }
                }

				console.log('Doing a sanitize!!!',this.component, this.options);
			},
			clearOptions() {
				for (let prop in this.options) {
					if (this.options.hasOwnProperty(prop)) {
						Vue.delete(this.options, prop);
					}
				}
			},
			setDefaultOptions() {
				this.clearOptions();

				this.options = Object.assign({}, this.options, this.defaultOptions);

				switch (this.component) {
					case 'RawMedia':
						this.options = Object.assign({}, this.options, this.defaultMediaOptions);
						break;
					case 'Points':
						this.options = Object.assign({}, this.options, this.defaultPointsOptions);
						break;
					case 'Choices':
						this.options = Object.assign({}, this.options, this.defaultChoicesOptions);
						break;
					case 'Phone':
						this.options = Object.assign({}, this.options, this.defaultMediaOptions);
						break;
					case 'Script':
						this.options = Object.assign({}, this.options, this.defaultScriptOptions);
						break;
				}
			},
			addChoice() {
				this.options.choices.push(this.createNewChoice());
				this.sendUpdate();
			},
			deleteChoice(index) {
				this.options.choices.splice(index, 1);
				this.sendUpdate();
			},
			addPoint() {
				this.options.points.push('');
				this.sendUpdate();
			},
			deletePoint(index) {
				this.options.points.splice(index, 1);
				this.sendUpdate();
			},
            createNewChoice () {
                if (this.gotoPageDisabled) {
                    return {
                        message: '',
                        format: this.formatTypes[0],
                    }
                } else {
                    return {
                        gotoPageIndex: this.pageIndex + 1,
                        message: '',
                        format: this.formatTypes[0],
                    }
                }
            },
			addDialogue() {
				this.options.dialogue.push({
					action: '',
					sentence: ''
				});
				this.sendUpdate();
			},
			deleteDialogue(index) {
				this.options.dialogue.splice(index, 1);
				this.sendUpdate();
			}
		},
		computed: {
			component() {
				return this.componentTypes[this.componentIndex];
			},
			componentTypes() {
				let types = [];
				if (this.pageType == 'dilemma') {
					types = ['Text', 'Points', 'Phone', 'RawMedia'];
					if (!this.isLastPage) {
						types.push('Choices');
					}
				} else if (this.pageType == 'roleplay') {
					types = ['Script', 'RawMedia']
				}

				return types;
			},
			resultTypes() {
				return ['correctAnswer', 'noAnswer', 'chooseAnswer'];
			},
			formatTypes() {
				return ['raw', 'sendMessage'];
			},
			showGoToPage() {
				return this.pageType == 'dilemma' && !this.isLastPage && this.position == 'Left' && (this.component != 'Choices' || this.options.resultType == 'noAnswer');
			},
			possibleGotoIndices() {
				let indices = [];
				for (let i = 0; i < this.pagesInCase; i++) {
					if (i != this.pageIndex) {
						indices.push(i);
					}
				}
				return indices;
			},
			defaultOptions() {
				return {
					text: '',
					gotoPageIndex: this.pageIndex + 1,
					backButton: false
				}
			},
			defaultMediaOptions() {
				return {
					media: ''
				}
			},
			defaultPointsOptions() {
				return {
					points: ['']
				}
			},
			defaultChoicesOptions() {
				return {
					choices: [this.createNewChoice()],
					resultType: this.resultTypes[0]
				}
			},
			defaultScriptOptions() {
				return {
					nextMessage: '',
					dialogue: []
				}
			},
			isMediaLinkValid() {
				return MediaManager.urlIsVimeo(this.options.media) || MediaManager.urlIsYoutube(this.options.media);
			},
			isLastPage() {
				return this.pageIndex == this.pagesInCase - 1;
			},
            gotoPageDisabled() {
                return true;
            }
		}
	}
</script>

<style lang="less" scoped>
	.invalid-feedback {
		font-size: 14px;
	}
</style>
